import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, mergeMap } from 'rxjs';
import { ClientsServices } from '../../domain/services/clients.service';
import { ClientsActions } from './clients.actions';

@Injectable()
export class ClientsEffects {
  constructor(
    private actions$: Actions,
    private clientsService: ClientsServices,
    private store$: Store
  ) {}

  allClients$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.getAllClients),
      mergeMap((action) => {
        return this.clientsService.getAllClients(action.companyId).pipe(
          map((clients) => ClientsActions.getAllClientsSuccess({ clients })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.getAllClientsFailure({ failure })
          )
        );
      })
    );
  });

  createClient$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.createClient),
      mergeMap((action) => {
        return this.clientsService.createClient(action.client).pipe(
          map((response) => ClientsActions.createClientSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.createClientFailure({ failure })
          )
        );
      })
    );
  });

  removeClient$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.removeClient),
      mergeMap((action) => {
        return this.clientsService.removeClient(action.client).pipe(
          map((response) => ClientsActions.removeClientSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.removeClientFailure({ failure })
          )
        );
      })
    );
  });

  clientById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.clientById),
      mergeMap((action) => {
        return this.clientsService.getClientById(action.clientId).pipe(
          map((response) => ClientsActions.clientByIdSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.clientByIdFailure({ failure })
          )
        );
      })
    );
  });

  removeMember$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.removeMember),
      mergeMap((action) => {
        return this.clientsService.removeMember(action.memberId).pipe(
          map((response) => ClientsActions.removeMemberSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.removeMemberFailure({ failure })
          )
        );
      })
    );
  });

  memberById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.memberById),
      mergeMap((action) => {
        return this.clientsService.getMemberById(action.memberId).pipe(
          map((response) => ClientsActions.memberByIdSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.memberByIdFailure({ failure })
          )
        );
      })
    );
  });

  updateMember$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.updateMember),
      mergeMap((action) => {
        return this.clientsService
          .updateMember(action.member, action.memberId)
          .pipe(
            map((response) => ClientsActions.updateMemberSuccess({ response })),
            catchAndGetFromFailureRxOp((failure) =>
              ClientsActions.updateMemberFailure({ failure })
            )
          );
      })
    );
  });

  addMember$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.addMember),
      mergeMap((action) => {
        return this.clientsService.addMember(action.member).pipe(
          map((response) => ClientsActions.addMemberSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.addMemberFailure({ failure })
          )
        );
      })
    );
  });
  updateClient$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.updateClient),
      mergeMap((action) => {
        return this.clientsService
          .updateClient(action.client, action.clientId)
          .pipe(
            map((response) => ClientsActions.updateClientSuccess({ response })),
            catchAndGetFromFailureRxOp((failure) =>
              ClientsActions.updateClientFailure({ failure })
            )
          );
      })
    );
  });
  pendingRequestsByClient$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.getPendingRequestsByMember),
      mergeMap((action) => {
        return this.clientsService
          .getPendingRequestsByMember(action.member)
          .pipe(
            map((response) =>
              ClientsActions.getPendingRequestsByMemberSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              ClientsActions.getPendingRequestsByMemberFailure({ failure })
            )
          );
      })
    );
  });
  addMultipleMembers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.addMultipleMembers),
      mergeMap((action) => {
        return this.clientsService.addMultipleMembers(action.members).pipe(
          map((response) =>
            ClientsActions.addMultipleMembersSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.addMultipleMembersFailure({ failure })
          )
        );
      })
    );
  });
  removeAndAssign$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClientsActions.removeAndAssign),
      mergeMap((action) => {
        return this.clientsService.removeMemberAndAssign(action.data).pipe(
          map((response) =>
            ClientsActions.removeAndAssignSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            ClientsActions.removeAndAssignFailure({ failure })
          )
        );
      })
    );
  });
}
export const ClientsEffectsModule = EffectsModule.forFeature([ClientsEffects]);
